import {
	Height as CardSize,
	RenderVariant,
	SegmentationTargets,
} from '@atlassian/company-hub-common';

export const DEFAULT_DYNAMIC_CARDS_COUNT = 3;

export const DEFAULT_CARDS_SIZE = CardSize.MEDIUM;

export { CardSize };

export type CardsExtensionParameters = {
	size: CardSize;
	segmentationTarget?: SegmentationTargets;
	audienceSegmentationGroupIds?: string[]; // group preferences stored via this field when segmentationTarget is ALL
	cards: Card[];
	extensionTitle: string;
	version: string;
	renderVariant: RenderVariant;
	cardCount?: number;
	filters?: Filters;
	isPublishDateShown: boolean;
	isAvatarShown: boolean;
	isLabelShown?: boolean;
	isSegmentationShown: boolean;
	orientation?: Orientation;
	alignment?: Alignment;
	isAutoscrollEnabled?: boolean;
	isPaddingEnabled?: boolean;
	layout?: CardsLayout;
	backgroundColor?: string;
	textColor?: string;
	borderColor?: string;
};

export enum Orientation {
	ROW = 'row',
	STACKED = 'stacked',
}

export enum Alignment {
	LEFT = 'left',
	CENTER = 'center',
	RIGHT = 'right',
}

export type Filters = {
	[filter: string]: any;
};

export enum ImagePosition {
	TOP = 'top',
	MIDDLE = 'middle',
	BOTTOM = 'bottom',
}

export type Card = {
	cardId: string;
	link: string;
	isLinkUserEdited?: boolean;
	title?: string;
	isTitleUserEdited?: boolean;
	description?: string;
	isDescriptionUserEdited?: boolean;
	label?: string;
	isLabelHidden?: boolean;
	imageSrc?: string;
	imagePosition?: ImagePosition;
	imageAltText?: string;
	confluencePageId?: string;
	audienceSegmentationGroupIds?: string[];
	linkResourceType?: string;
	backgroundColor?: string;
	textColor?: string;
	labelColor?: string;
};

export type ResolvedLinkDataObject = {
	data: {
		summary?: string;
		name?: string;
		image?: {
			url?: string;
		};
	};
	meta: {
		objectId?: string;
		resourceType?: string;
	};
};

export enum CardsLayout {
	FIXED_IMAGE_HEIGHT = 'fixed-image-height',
	FLEXIBLE_IMAGE_HEIGHT = 'flexible-image-height',
}
